(function(){
  function buildSwatchMap(){
    var dataEl = document.getElementById('colorSwatchData');
    if(!dataEl) return {};
    try {
      var data = JSON.parse(dataEl.textContent);
      var map = {};
      if(Array.isArray(data.color_swatch_name)){
        data.color_swatch_name.forEach(function(name, idx){
          var key = name ? name.toLowerCase().replace(/\s+/g,'') : '';
          map[key] = data.color_swatch_value[idx];
        });
      }
      return map;
    } catch(e){
      return {};
    }
  }

  var swatchMap = buildSwatchMap();

  function setSwatchStyle(node, val){
    if(!val) return;
    var isColor = (window.CSS && CSS.supports && CSS.supports('background-color', val));
    if(isColor){
      node.style.backgroundColor = val;
      node.style.backgroundImage = '';
    } else {
      node.style.backgroundImage = 'url(' + val + ')';
      node.style.backgroundSize = 'cover';
      node.style.backgroundPosition = 'center';
      node.style.backgroundRepeat = 'no-repeat';
    }
  }

  function applyColorSwatches(scope){
    var context = scope || document;
    var nodes = context.querySelectorAll('.product-swatches');
    if(!nodes.length) return;

    nodes.forEach(function(node){
      var val = node.getAttribute('data-swatch-option-value');
      if(!val){
        var opt = node.getAttribute('data-option-value');
        if(opt && swatchMap[opt]){
          val = swatchMap[opt];
        }
      }
      setSwatchStyle(node, val);

      if(!val) return;
      if(/^(https?:)?\/\//.test(val) || /\.(jpe?g|png|gif|svg|webp)$/.test(val)){
        node.style.backgroundImage = 'url(' + val + ')';
        node.style.backgroundSize = 'cover';
        node.style.backgroundPosition = 'center';
        node.style.backgroundRepeat = 'no-repeat';
      } else {
        node.style.backgroundColor = val;
      }
    });
  }

  function init(e){
    applyColorSwatches(e && e.target);
  }

  document.addEventListener('DOMContentLoaded', function(){
    init();
    if('MutationObserver' in window){
      var observer = new MutationObserver(function(mutations){
        mutations.forEach(function(m){
          m.addedNodes.forEach(function(n){
            if(n.nodeType !== 1) return;
            if(n.matches && n.matches('.product-swatches')){
              var val = n.getAttribute('data-swatch-option-value');
              if(!val){
                var opt = n.getAttribute('data-option-value');
                if(opt && swatchMap[opt]){
                  val = swatchMap[opt];
                }
              }
              setSwatchStyle(n, val);
            } else if(n.querySelectorAll){
              n.querySelectorAll('.product-swatches').forEach(function(child){
                var v = child.getAttribute('data-swatch-option-value');
                if(!v){
                  var o = child.getAttribute('data-option-value');
                  if(o && swatchMap[o]){
                    v = swatchMap[o];
                  }
                }
                setSwatchStyle(child, v);
              });
            }
          });
        });
      });
      observer.observe(document.body, {childList:true, subtree:true});
    }
  });
  document.addEventListener('shopify:section:load', init);
})();
